var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable } from 'inversify';
import wizardSprite from '@assets/images/wizard-attack.png';
import rangerSprite from '@assets/images/ranger-attack.png';
import { GameConfiguratorSingleton } from './GameConfiguratorSingleton';
import { DEFENDER_TYPE } from '@models/DefenderType';
import { SERVICE_IDENTIFIER } from '@config/service-identifier';
import { collision } from '@utils/collision';
import { CASTLE_WIDTH, CELL_GAP, CELL_SIZE, TOOLBAR_HEIGHT } from '@static/game';
import { DefenderFactory } from '@components/defenders/DefenderFactory';
var DefendersServiceImpl = /** @class */ (function () {
    function DefendersServiceImpl(cartridgesService) {
        var _this = this;
        this.cartridgesService = cartridgesService;
        this.buyDefender = function () {
            var _a;
            var gridPositionX = _this._gameConfigurator.mouse.x -
                (_this._gameConfigurator.mouse.x % CELL_SIZE) +
                CELL_GAP;
            var gridPositionY = _this._gameConfigurator.mouse.y -
                (_this._gameConfigurator.mouse.y % CELL_SIZE) +
                CELL_GAP;
            var isCollision = _this._defenders.some(function (defender) {
                return defender.x === gridPositionX && defender.y === gridPositionY;
            });
            var defenderCost = (_a = _this._defendersData.find(function (defender) { return defender.type === _this._selectedDefenderType; })) === null || _a === void 0 ? void 0 : _a.cost;
            if (gridPositionY < TOOLBAR_HEIGHT ||
                gridPositionX < CASTLE_WIDTH ||
                isCollision)
                return;
            if (defenderCost && _this._gameConfigurator.balance >= defenderCost) {
                _this._defenders.push(DefenderFactory.createDefender(_this._selectedDefenderType, gridPositionX, gridPositionY));
                _this._gameConfigurator.balance =
                    _this._gameConfigurator.balance - defenderCost;
            }
        };
        this._gameConfigurator = GameConfiguratorSingleton.getInstance();
        this._defenders = [];
        this._timer = 0;
        this._selectedDefenderType = DEFENDER_TYPE.RANGER;
        var rangerImage = new Image();
        rangerImage.src = rangerSprite;
        var wizardImage = new Image();
        wizardImage.src = wizardSprite;
        this._defendersData = [
            {
                type: DEFENDER_TYPE.RANGER,
                cost: 100,
                image: rangerImage,
            },
            {
                type: DEFENDER_TYPE.WIZARD,
                cost: 200,
                image: wizardImage,
            },
        ];
    }
    DefendersServiceImpl.prototype.selectDefender = function (mouses) {
        var _this = this;
        mouses.forEach(function (mouse, index) {
            if (collision(_this._gameConfigurator.mouse, mouse)) {
                _this._selectedDefenderType = _this._defendersData[index].type;
            }
        });
    };
    DefendersServiceImpl.prototype.removeDefenderByIndex = function (index) {
        this._defenders.splice(index, 1);
    };
    DefendersServiceImpl.prototype.drawDefenders = function () {
        var _this = this;
        this._defenders.forEach(function (defender) {
            defender.draw();
            defender.shoot(_this.cartridgesService.cartridges);
        });
    };
    Object.defineProperty(DefendersServiceImpl.prototype, "defenders", {
        get: function () {
            return this._defenders;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefendersServiceImpl.prototype, "defendersData", {
        get: function () {
            return this._defendersData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefendersServiceImpl.prototype, "selectedDefenderType", {
        get: function () {
            return this._selectedDefenderType;
        },
        enumerable: false,
        configurable: true
    });
    DefendersServiceImpl = __decorate([
        injectable(),
        __param(0, inject(SERVICE_IDENTIFIER.CARTRIDGES_SERVICE))
    ], DefendersServiceImpl);
    return DefendersServiceImpl;
}());
export { DefendersServiceImpl };
